"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const scroll_bar_helper_styles_1 = __importDefault(require("./scroll-bar-helper.styles"));
function ScrollBarHelper({ displayMode = 'default' }) {
    (0, react_2.useEffect)(() => {
        var _a, _b;
        if (['banner'].includes(displayMode)) {
            (_a = document.querySelector('html')) === null || _a === void 0 ? void 0 : _a.classList.add('root_scroll-bar_disabled');
            (_b = document.querySelector('body')) === null || _b === void 0 ? void 0 : _b.classList.add('root_scroll-bar_disabled');
        }
    }, [displayMode]);
    return (0, jsx_runtime_1.jsx)(react_1.Global, { styles: scroll_bar_helper_styles_1.default });
}
exports.default = ScrollBarHelper;
